import Image from "next/image";
import React from "react";
import SideDrawer from "./SideDrawer";
import { Sheet, SheetTrigger } from "@/components/ui/couponsSheet";
import axios from "axios";
import mixpanel from "@/utils/mixpanel";

export default function SelectCoupon({
  coupons,
  originalOrderAmount,
  setCouponDiscount,
  setFinalCouponSelected,
  isSelectCouponEnabled,
  phoneNumber,
  bootcampTitle,
  marketingPage = false,
}: {
  coupons: any[] | undefined;
  originalOrderAmount: number;
  setCouponDiscount: Function;
  setFinalCouponSelected: Function;
  isSelectCouponEnabled: boolean;
  phoneNumber: string;
  bootcampTitle?: string;
  marketingPage?: boolean;
}) {
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);
  const [couponSelected, setCouponSelected] = React.useState<boolean>(false);
  const [selectedCoupon, setSelectedCoupon] = React.useState<any>();
  const [availableCoupons, setAvailableCoupons] = React.useState<any[]>(
    coupons || []
  );
  const calculateDiscount = (couponData: any) => {
    originalOrderAmount = originalOrderAmount;
    let maxDiscount = (originalOrderAmount * couponData?.discountPercent) / 100;
    if (maxDiscount > couponData?.maxDiscountPrice) {
      maxDiscount = couponData?.maxDiscountPrice;
    }
    setCouponDiscount(maxDiscount);
    return maxDiscount;
  };
  React.useEffect(() => {
    if (isSelectCouponEnabled && phoneNumber) {
      axios
        .get(
          `${process.env.NEXT_PUBLIC_BASE_API}coupons/user-specific/phone/${phoneNumber}?website=astrolearn`
        )
        .then((res) => {
          let allCoupons = [];
          if (coupons) {
            allCoupons.push(...coupons);
          }
          if (res.data.data) {
            for (const coupon of res.data.data) {
              coupon.isUserSpecificCoupon = true;
              coupon.isCategoryCoupon = !!coupon.categories?.find((item:{id:string,name:string})=>item.name=="Spirituality");
              allCoupons.push(coupon);
            }
          }
          setAvailableCoupons(allCoupons);
        })
        .catch((error) => {
          console.log("error while fetching user specific coupons: ", error);
        });
    }
  }, [isSelectCouponEnabled]);
  React.useEffect(() => {
    const isCategoryCoupon = !!selectedCoupon?.categories?.find((category?:{id?:string,name?:string})=>category?.name==="Spirituality")
    setFinalCouponSelected({...selectedCoupon,isCategoryCoupon:isCategoryCoupon});
  }, [selectedCoupon]);
  return (
    <>
      {couponSelected ? (
        <>
          <div className="w-full h-full flex-col justify-start items-start gap-1 inline-flex text-sm">
            <div className="justify-start items-center gap-1 inline-flex">
              <Image
                src="/coupons/applyCoupon.svg"
                alt="Coupon Applied"
                width={20}
                height={20}
                className="relative"
              />
              <div className="text-[#434651] font-semibold font-lato">
                Coupon Applied
              </div>
            </div>
            <div
              className={`${
                marketingPage ? "w-full" : "self-stretch"
              } px-3.5 py-2.5 bg-white rounded-lg border border-dashed ${
                marketingPage ? "border-amber-600" : "border-[#aaaaaa]"
              } flex-col justify-center items-start gap-2 flex`}
            >
              <div className="self-stretch justify-between items-center inline-flex">
                <div className="text-center">
                  <span className="text-[#0a2133] font-semibold font-lato">
                    '{`${selectedCoupon?.code}`}'
                  </span>
                  <span className="text-[#0a2133]/80 font-medium font-lato">{` applied`}</span>
                </div>
                <div
                  onClick={() => {
                    setCouponSelected(false);
                    setCouponDiscount(0);
                    setFinalCouponSelected(undefined);
                    setSelectedCoupon(undefined);
                    if (!marketingPage) {
                      mixpanel.track("coupon_remove", {
                        bootcamp: bootcampTitle,
                        source: "Astrolearn",
                      });
                    }
                  }}
                  className="cursor-pointer text-[#fa3d53] font-semibold font-lato"
                >
                  REMOVE
                </div>
              </div>
              <div className="w-fit text-[#71ad53]/80 font-semibold font-lato uppercase">
                You got extra ₹{calculateDiscount(selectedCoupon)} Off
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Sheet
            open={openDrawer && isSelectCouponEnabled}
            onOpenChange={setOpenDrawer}
          >
            <SheetTrigger
              asChild
              type="button"
              onClick={() => {
                mixpanel.track("apply_coupon_click", {
                  bootcamp: bootcampTitle,
                  source: "Astrolearn",
                });
              }}
            >
              <div>
                <div
                  className={`cursor-pointer h-full w-full px-3 py-2.5 bg-white ${
                    marketingPage ? "rounded-t-lg" : "rounded-lg"
                  } border border-dashed ${
                    marketingPage ? "border-amber-600" : "border-[#aaaaaa]"
                  }  justify-start items-center gap-2.5 inline-flex`}
                >
                  <Image
                    alt="Percentage icon for coupon"
                    width={6}
                    height={6}
                    src="/coupons/applyCoupon.svg"
                    className="w-6 h-6 relative"
                  />
                  <div className="text-[#434651] text-sm font-semibold font-lato">
                    Apply Coupon
                  </div>
                </div>
                {marketingPage && (
                  <div className="rounded-b-lg h-[22px] text-white font-semibold bg-amber-600/70 text-center relative py-0.5">
                    <div className="absolute inset-0 bg-[linear-gradient(110deg,#00000000,45%,#ffffff80,55%,#00000000)] bg-[length:200%_100%] animate-shimmer rounded-md " />
                    Use Coupon for Extra discount!!!
                  </div>
                )}
              </div>
            </SheetTrigger>
            <SideDrawer
              phoneNumber={phoneNumber}
              selectedCoupon={selectedCoupon}
              setSelectedCoupon={setSelectedCoupon}
              setOpenDrawer={setOpenDrawer}
              setCouponSelected={setCouponSelected}
              coupons={availableCoupons}
              bootcampTitle={bootcampTitle}
            />
          </Sheet>
        </>
      )}
    </>
  );
}
